import { ReminderOption } from 'api/notifications/configuration';
import { EventType } from 'api/notifications/meta';
import { IntegrationConfig } from '../types';

export enum ChannelMappingOptions {
  NewChannel = 'CREATE_NEW_PER_PROJECT',
  FixedChannel = 'FIXED',
}

export type SlackUser = {
  id: string;
  name: string;
};

export type SlackChannel = {
  id: string;
  name: string;
};

export type SlackSettingsMeta = {
  fixedChannelId?: string;
  fixedChannel?: SlackChannel;
  externalAccountId: string;
  usersToAddToChannel?: SlackUser[];
  addSpecificUsersToChannel: boolean;
  addAllProjectMembersToChannel: boolean;
  channelMappingMechanism: ChannelMappingOptions;
};

export type SlackConfig = IntegrationConfig<SlackSettingsMeta>;

export type SlackProjectSettings = {
  doNoNotify: true;
  channel: {
    name: string;
    id: string;
    archived: boolean;
    deleted: boolean;
  };
};

// TODO: this will extend and any will be removed ocne integrated with BE
export type SlackNotificationEvent = {
  eventType: EventType;
  channels: {
    SLACK: boolean;
  };
  meta?: { type?: ReminderOption };
};
